import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"
import { popularPrefectures, otherPrefectures } from "../utils/prefectures"

const SearchTabs = ({ blok, hideBubble, destination, prefecture, season, typeOfTour, keyword, label, interest, duration }) => {
  // console.log(blok)
  // console.log(prefecture, season, typeOfTour, keyword)

  const { destinationFilter, interestFilter } = useStaticQuery(graphql`
  query {
    destinationFilter: allStoryblokDatasourceEntry(filter: { data_source: { eq: "tour-destination-filter" } }) {
      edges {
        node {
          id
          name
          value
          data_source
        }
      }
    },
    interestFilter: allStoryblokDatasourceEntry(filter: { data_source: { eq: "tour-interest-filter" } }) {
      edges {
        node {
          id
          name
          value
          data_source
        }
      }
    }
  }
  `)
  // console.log(destinationFilter, interestFilter)
  
  let destinationGroup = [];
  destinationFilter.edges.forEach(({ node }) => {
    if (node.value == '-') {
      destinationGroup.push({
        label: node.name,
        destinations: []
      });
    }
    else if (destinationGroup.length > 0) {
      destinationGroup[destinationGroup.length - 1].destinations.push(node);
    }
  });

  const [selectedSeason, setSelectedSeason] = useState(season || '');

  return (
    <div className="container max-w-screen-lg mx-auto" {...storyblokEditable(blok)}>
      { !hideBubble &&
      <div className="m-4 text-center h-0 flex items-center justify-end">
        <a className="z-10" href="tel:646-770-9043"><img className="h-auto w-[240px]" loading="lazy" src="/img/en-tel.png" alt="tel" /></a>
      </div>
      }

      <div className="mb-4 border-b border-gray-200">
        <ul className="flex -mb-px font-medium text-center">
          <li className="me-2">
            <button className="inline-block p-3 border-b-2 border-lime-300 rounded-t-lg" data-tabs-target="#tour">
              Search Tour
            </button>
          </li>
          {/* <li className="me-2">
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300">
              Find Flights
            </button>
          </li>
          <li className="me-2">
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300">
              Book Hotels
            </button>
          </li>
          <li>
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300">
              Rent Cars
            </button>
          </li> */}
        </ul>
      </div>

      <div className="mb-6 px-5">
        <div className="">
          <form method="GET" action="/tours" className="flex flex-col sm:flex-row justify-between gap-2">
            <div className="p-3 rounded-lg border border-gray-800 flex">
              <img className="mr-2 inline-block" src="/icons/search-section-pin.svg" alt="" />
              <select name="destination" className="outline-none w-full" defaultValue={destination}>
                <option value="">Destination</option>
                { destinationGroup.map((optGroup, i) => (
                  <optgroup key={i} label={optGroup?.label}>
                    { optGroup?.destinations.map((d) => (
                      <option key={d.value} value={d.value}>{d.name}</option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </div>
            

            <div className="p-3 rounded-lg border border-gray-800 flex">
              <img className="mr-2" src="/icons/tag.svg" alt="Tag icon"/>
              <select name="interest" className="outline-none w-full" defaultValue={interest}>
                <option value="">Interest</option>
                { interestFilter.edges.map(({ node }) => (
                  <option key={node.value} value={node.value}>{node.name}</option>
                ))}
              </select>
            </div>

            <div className="p-3 rounded-lg border border-gray-800 flex">
              <select name="duration" className="outline-none w-full" defaultValue={duration}>
                <option value="">Duration</option>
                <option value="1">1 Day</option>
                <option value="2-3">2-3 Days</option>
                <option value="4-7">4-7 Days</option>
                <option value="8-">8 Days or more</option>
              </select>
            </div>

            <div className="p-3 rounded-lg border border-gray-800 flex">
              {selectedSeason && <img className="mr-2 inline-block" loading="lazy" src={`/icons/${selectedSeason}.svg`} alt="" />}
              <select name="season" className="outline-none w-full" defaultValue={season} onChange={e => setSelectedSeason(e.target.value)}>
                <option value="">Season</option>
                <option value="all seasons">All Seasons</option>
                <option value="spring">Spring</option>
                <option value="summer">Summer</option>
                <option value="autumn">Autumn</option>
                <option value="winter">Winter</option>
              </select>
            </div>
            <div className="p-3 rounded-lg border border-gray-800 flex">
              <select name="typeOfTour" className="outline-none w-full" defaultValue={typeOfTour}>
                <option value="">Tour Type</option>
                <option value="">All</option>
                <option value="group">Group</option>
                <option value="private">Private</option>
                <option value="luxury">Luxury</option>
              </select>
            </div>
            {/* 
            <span className="self-center"> or </span>
            <div className="p-3 rounded-lg border border-gray-800">
              <input type="text" name="keyword" defaultValue={keyword} placeholder="Enter keywords here" className="outline-none w-full" />
            </div> 
            */}
            <button type="submit" className="bg-gray-800 text-white rounded-lg p-2">
              <img className="h-8 w-full" src="/icons/search-section-cta.svg" alt="Search tours"/>
            </button>
          </form>
        </div>
        <div className="hidden p-4 rounded-lg">
          <p className="">

          </p>
        </div>
        <div className="hidden p-4 rounded-lg">
          <p className="">
            
          </p>
        </div>
        <div className="hidden p-4 rounded-lg">
          <p className="">
          </p>
        </div>
      </div>
    </div>
  )
};

export default SearchTabs;
